import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

const SlackOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    // Get the authorization code and state from URL parameters
    const code = searchParams.get('code')
    const error = searchParams.get('error')
    const state = searchParams.get('state')

    if (error) {
      console.error('Slack OAuth error:', error)
      // Redirect to an error page or show error message
      window.location.href = `/install-success?error=${encodeURIComponent(error)}`
      return
    }

    if (code) {
      // Forward the OAuth callback to the Supabase Edge Function
      const supabaseOAuthUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/slack-oauth`
      const params = new URLSearchParams()
      params.append('code', code)
      if (state) {
        params.append('state', state)
      }

      const fullUrl = `${supabaseOAuthUrl}?${params.toString()}`
      
      console.log('Forwarding OAuth callback to Supabase Edge Function:', fullUrl)
      
      // Redirect to the Supabase Edge Function to complete the OAuth flow
      window.location.href = fullUrl
    } else {
      console.error('No authorization code received from Slack')
      window.location.href = '/install-success?error=No authorization code received'
    }
  }, [searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <h2 className="mt-4 text-lg font-semibold text-foreground">Processing Slack Installation...</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Please wait while we complete the setup for your workspace.
        </p>
      </div>
    </div>
  )
}

export default SlackOAuthCallback
